module.exports = __webpack_public_path__ + "static/media/sort-desc.7ffa34f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/sort-desc.svg
// module id = 1521
// module chunks = 0